import moment from "moment";

export const RENTACAR_CONSTANTS = {
  DEFAULT_TIME_RANGE: [
    moment().add(1, "day").set("hour", 10).set("minute", 0).set("second", 0),
    moment().add(1, "day").set("hour", 11).set("minute", 0).set("second", 0),
  ],
  TIMETABLE: {
    winter: {
      morning: {
        open: {
          hour: 9,
          minute: 30,
        },
        close: {
          hour: 14,
          minute: 30,
        },
      },
      afternoon: {
        open: {
          hour: 14,
          minute: 30,
        },
        close: {
          hour: 17,
          minute: 0,
        },
      },
    },
    summer: {
      morning: {
        open: {
          hour: 10,
          minute: 0,
        },
        close: {
          hour: 12,
          minute: 30,
        },
      },
      afternoon: {
        open: {
          hour: 15,
          minute: 0,
        },
        close: {
          hour: 17,
          minute: 30,
        },
      },
    },
  },
  TYPOLOGY: ["visitor", "resident", "company", "coworker"],
  DEFAULT_TYPE: "visitor",
  TRANSFER_LOCS: [
    {
      label: "Sem transfer",
      value: "no_transfer",
    },
    {
      label: "Terminal Ferroviário de Castelo Novo",
      value: "tf_castelo_novo",
    },
    {
      label: "Terminal Ferroviário do Fundão",
      value: "tf_fundao",
    },
    {
      label: "Terminal Ferroviário de Alpedrinha",
      value: "tf_alpedrinha",
    },
  ],
  AVAILABLE_TIME: [
    "08:00",
    "08:15",
    "08:30",
    "08:45",
    "09:00",
    "09:15",
    "09:30",
    "09:45",
    "10:00",
    "10:15",
    "10:30",
    "10:45",
    "11:00",
    "11:15",
    "11:30",
    "11:45",
    "12:00",
    "12:15",
    "12:30",
    "12:45",
    "13:00",
    "13:15",
    "13:30",
    "13:45",
    "14:00",
    "14:15",
    "14:30",
    "14:45",
    "15:00",
    "15:15",
    "15:30",
    "15:45",
    "16:00",
    "16:15",
    "16:30",
    "16:45",
    "17:00",
    "17:15",
    "17:30",
    "17:45",
    "18:00",
    "18:15",
    "18:30",
    "18:45",
    "19:00",
    "19:15",
    "19:30",
    "19:45",
    "20:00",
  ],
};
